import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
    storageKey: 'formforge-auth-token',
    lock: undefined,
  },
  global: {
    fetch: (...args) =>
      fetch(...args)?.catch((err) => {
        // Suppress token refresh fetch errors — AuthContext handles session cleanup
        console.warn('Supabase fetch error (suppressed):', err?.message);
        return new Response(JSON.stringify({ error: { message: 'Failed to fetch' } }), {
          status: 0,
          headers: { 'Content-Type': 'application/json' },
        });
      }),
  },
});
